module.exports = __webpack_public_path__ + "img/8.2ac5ac1b.png";